module.exports = __webpack_public_path__ + "static/media/image_8.2371eb0a.png";